import React from 'react'
import { Event } from 'interfaces/entities/event.model'
import { toDate } from 'helpers/dateHelper'
import { Badge, Card, CardContent } from '@mui/material'
import { FaArrowRight } from 'react-icons/fa'

interface EventItemProps {
    event: Event
}
export const EventItem = ({ event }: EventItemProps) => {
    if (!event) {
        return null
    }

    if (event.eventType === "LEAD_CREATED") {
        return <Card>
            <CardContent>
                <div className='flex items-center gap-2'>
                    <strong>Сделка создана</strong>
                    <span className='text-sm text-gray-500'>{toDate(event.createdAt)}</span>
                </div>
                <div className='py-4 flex items-center gap-2'>
                    <span>{event.actorName || event.payload.actorName}:</span>
                    <span className=''>{event.payload.name}</span>
                </div>
            </CardContent>
        </Card>
    }

    if (event.eventType === "STATUS_CHANGED") {
        return <Card>
            <CardContent>
                <div className='flex items-center gap-2'>
                    <strong>Стадия изменена</strong>
                    <span className='text-sm text-gray-500'>{toDate(event.createdAt)}</span>
                </div>
                <div className='py-4 flex items-center gap-2'>
                    <Badge color="primary" variant="standard">
                        {event.payload.from}
                    </Badge>
                    <FaArrowRight className='text-gray-500' />
                    <Badge color="primary" variant="standard">
                        {event.payload.to}
                    </Badge>
                </div>
            </CardContent>
        </Card>
    }
    if (event.eventType === "COMMENT_ADDED") {
        return <Card>
            <CardContent>
                <div className='flex items-center gap-2'>
                    <strong>Комментарий добавлен</strong>
                    <span className='text-sm text-gray-500'>{toDate(event.createdAt)}</span>
                </div>
                <div className='py-4 flex items-center gap-2'>
                    <span>{event.actorName || event.payload.actorName}:</span>
                    <span>{event.payload.text}</span>
                </div>
            </CardContent>
        </Card>
    }

    // Name changed
    if (event.eventType === "NAME_CHANGED") {
        return <Card>
            <CardContent>
                <div className='flex items-center gap-2'>
                    <strong>Название сделки изменено</strong>
                    <span className='text-sm text-gray-500'>{toDate(event.createdAt)}</span>
                </div>
                <div className='py-4 flex items-center gap-2'>
                    <span>{event.actorName || event.payload.actorName}:</span>
                    <span>{event.payload.from}</span>
                    <FaArrowRight className='text-gray-500' />
                    <span>{event.payload.to}</span>
                </div>
            </CardContent>
        </Card>
    }

    // Price changed
    if (event.eventType === "PRICE_CHANGED") {
        return <Card>
            <CardContent>
                <div className='flex items-center gap-2'>
                    <strong>Цена сделки изменена</strong>
                    <span className='text-sm text-gray-500'>{toDate(event.createdAt)}</span>
                </div>
                <div className='py-4 flex items-center gap-2'>
                    <span>{event.actorName || event.payload.actorName}:</span>
                    {event.payload.from}
                    <FaArrowRight className='text-gray-500' />
                    {event.payload.to}
                </div>
            </CardContent>
        </Card>
    }

    return null
}
